import { ListBadgesResponse, Badge as V3Badge } from '@wix/ambassador-badges-v3-badge/types';
import { ListResponse, Badge } from '@wix/ambassador-badges-v1-badge/types';
import createAction from '../../common/services/create-action';
import { CommonRequest } from '../types';

export const FETCH_BADGES_REQUEST = 'badges/FETCH_REQUEST';
export const FETCH_BADGES_SUCCESS = 'badges/FETCH_SUCCESS';
export const FETCH_BADGES_FAILURE = 'badges/FETCH_FAILURE';

export const fetchBadgesRequest = createAction(FETCH_BADGES_REQUEST);
export const fetchBadgesSuccess = createAction(FETCH_BADGES_SUCCESS, (payload: Badge) => payload);
export const fetchBadgesFailure = createAction(FETCH_BADGES_FAILURE);

const mapV1ToV3 = (badge: V3Badge): Badge => ({
  id: badge.id,
  title: badge.title ?? undefined,
  description: badge.description ?? undefined,
  backgroundColor: badge.backgroundColor ?? undefined,
  textColor: badge.textColor ?? undefined,
  icon: badge.icon ?? undefined,
  roleId: badge.id,
  hasPermissions: badge.permissionsEnabled ?? undefined,
  slug: badge.slug ?? undefined,
  dateCreated: badge.createdDate,
  dateUpdated: badge.createdDate,
});

export const fetchBadges = () => {
  return (
    dispatch: any,
    getState: any,
    {
      badgesV3Request,
    }: {
      badgesV3Request: CommonRequest;
    },
  ) => {
    dispatch(fetchBadgesRequest());
    const config = {
      headers: {
        instance: null,
      },
    };

    const promise = badgesV3Request<ListBadgesResponse>('/v3/badges', config).then((listBadgesResponse) => ({
      badges: listBadgesResponse.badges?.map((badge) => mapV1ToV3(badge)) ?? [],
    }))

    return promise.then(
      (res: ListResponse) => dispatch(fetchBadgesSuccess(res?.badges || [])),
      () => dispatch(fetchBadgesFailure()),
    );
  };
};
